// Whether DMs and mentions show a pop-up in the page. People turn it off in
// Settings; the choice is kept in this browser, as sound is.

const key = "lantern.popups";

export function popUpsOn(): boolean {
  try {
    return localStorage.getItem(key) !== "off";
  } catch {
    return true;
  }
}

export function setPopUps(on: boolean) {
  try {
    localStorage.setItem(key, on ? "on" : "off");
  } catch {
    // Private windows may refuse; the choice lasts until reload.
  }
}
